import {Component, input} from '@angular/core';
import {IACKATHON_STEP} from '../../models/iackathon_steps';
import {IackathonSave} from '../../services/iackathon-saves.service';
import {IackathonStepCanvasComponent} from './steps-details-components/iackathon-step-canvas/iackathon-step-canvas.component';
import {IackathonStepDeliverableComponent} from './steps-details-components/iackathon-step-deliverable/iackathon-step-deliverable.component';
import {IackathonStepFinalIdeaComponent} from './steps-details-components/iackathon-step-final-idea/iackathon-step-final-idea.component';
import {IackathonStepHowNowWowComponent} from './steps-details-components/iackathon-step-how-now-wow/iackathon-step-how-now-wow.component';
import {IackathonStepKeyNumberComponent} from './steps-details-components/iackathon-step-key-number/iackathon-step-key-number.component';
import {IackathonStepProblematicComponent} from './steps-details-components/iackathon-step-problematic/iackathon-step-problematic.component';
import {IackathonStepRateComponent} from './steps-details-components/iackathon-step-rate/iackathon-step-rate.component';
import {IackathonStepRatingOthersComponent} from './steps-details-components/iackathon-step-rating-others/iackathon-step-rating-others.component';

@Component({
  selector: 'app-iackathon-step-details',
    imports: [
        IackathonStepKeyNumberComponent,
        IackathonStepProblematicComponent,
        IackathonStepHowNowWowComponent,
        IackathonStepFinalIdeaComponent,
        IackathonStepCanvasComponent,
        IackathonStepDeliverableComponent,
        IackathonStepRatingOthersComponent,
        IackathonStepRateComponent
    ],
  templateUrl: './iackathon-step-details.component.html',
  styleUrl: './iackathon-step-details.component.scss',
})
export class IackathonStepDetailsComponent {
    step = input.required<IACKATHON_STEP>()
    save = input.required<IackathonSave>()
}
